export default function KpiCard({ label, value, icon: Icon, onClick, accent = "text-slate-900", testId }) {
  return (
    <div
      data-testid={testId}
      onClick={onClick}
      className={`card-surface card-surface-hover rounded-xl border border-slate-200 bg-white shadow-sm p-6 ${onClick ? "cursor-pointer hover:shadow-md hover:-translate-y-0.5" : ""} transition-transform duration-150`}
    >
      <div className="flex items-center justify-between">
        <p className="text-sm text-slate-600">{label}</p>
        {Icon && <Icon className="h-4 w-4 text-slate-400" />}
      </div>
      <p className={`mt-2 text-3xl font-semibold ${accent}`}>{value}</p>
    </div>
  );
}
